module.exports = {
  // App Info
  appstore_link         : "#",                                  // Enter App Store URL.
  playstore_link        : "#",                                  // Enter Google Play Store URL.
  google_analytics_ID   : "UA-160618583-1",                                        // Enter Google Analytics ID or ""
  presskit_download_link: "https://how2herb.com",                                  // Enter a link to downloadable file or (e.g. public Dropbox link to a .zip file). 
  video_or_screenshot   : "screenshot",                                           // "screenshot" or "video"
  app_url               : "https://how2herb.com",                            // Domain of your website without path_prefix.
  path_prefix           : "/",                                                    // Prefixes all links. For cases when deployed to example.github.io/automatic-gatsbyjs-app-landing-page/.
  app_name              : "How 2 Herb",
  app_price             : "Free",
  app_description       : "Introducing How 2 Herb, a consumer focused app geared towards cannabis discovery in order to understand strains, products and brands that benefit your current mood or condition and to avoid those are less effective.",
  app_keywords          : ["cbd", "hemp", "app", "cannabis"],

  // Personal Info
  your_name              : "How 2 Herb",
  your_link              : "https://how2herb.com",
  your_city              : "Orange County, CA",
  email_address          : "info@how2herb.com",
  linkedin_username      : null,
  facebook_username      : "how2herb",
  instagram_username     : "how2herb",
  twitter_username       : "how2herb",
  github_username        : null,
  youtube_username       : null,

  // Features List
  features               : [
    {
      title: "Simple Navigation",
      description:
        "Patent-pending Arc menu design allows for simple navigation based on how you feel vs product claims",
      fontawesome_icon_name: "compass",
    },
    {
      title: "Journaling",
      description:
        "Record your results over time with tags and simple star rating to learn what products work best for you.",
      fontawesome_icon_name: "journal-whills",
    },
    {
      title: "Easy Purchasing",
      description:
        "Shopping cart with easy checkout.",
      fontawesome_icon_name: "shopping-cart",
    },
    {
      title: "Statistics Profile",
      description:
        "Keep track of what products work best, which products don't work so well for you and your activity.",
      fontawesome_icon_name: "chart-line",
    },
    // {
    //   title: "Easy to Tweak",
    //   description:
    //     "Tweak accent color, images, icons and transparency via the site-config.js file. No HTML/CSS needed.",
    //   fontawesome_icon_name: "adjust",
    // },
    // {
    //   title: "Feature List",
    //   description:
    //     "Add features (like this one) to your site via the site-config.js file. No HTML/CSS needed.",
    //   fontawesome_icon_name: "star",
    // },
    // {
    //   title: "Deploy to Netlify",
    //   description: "Easily deploy your GatsbyJS landing page to Netlify.",
    //   fontawesome_icon_name: "arrow-alt-circle-down",
    // },
    // {
    //   title: "Social Links",
    //   description:
    //     "Easily add social media accounts and contact info in the footer via the site-config.js file. No HTML/CSS needed.",
    //   fontawesome_icon_name: "link",
    // },
    // {
    //   title: "FontAwesome Support",
    //   description:
    //     "Pick custom Font Awesome icons for the feature list via the site-config.js file. No HTML/CSS needed.",
    //   fontawesome_icon_name: "info-circle",
    // },
  ],
  header_background             : "rgba(0, 0, 0, 0.1)",
  topbar_title_color            : "#ffffff",
  cover_overlay_color_rgba      : "rgba(54, 59, 61, 0.8)",
  device_color                  : "black",                          // Set to "black", "blue", "coral", "white", or "yellow"
  body_background_color         : "#000000",
  primary_text_color            : "#00FF00",
  content_width                 : "1170px",
  font                          : `"Helvetica Neue", sans-serif`,
  link_color                    : "#1d63ea",
  app_title_color               : "#ffffff",
  app_price_color               : "#ffffff",
  app_description_color         : "#ffffff",
  feature_title_color           : "#ffffff",
  feature_text_color            : "#666666",
  feature_icons_foreground_color: "#1d63ea",
  feature_icons_background_color: "#e6e6e6",
  social_icons_foreground_color : "#666666",
  social_icons_background_color : "#e6e6e6",
  footer_text_color             : "#666666",
}
